import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IAuthCheckRubikaTokenQuery, IAuthCheckShadTokenResult } from '@/Module/Auth/Model/ApiModel';
import { AuthService } from '@/Module/Auth/Service';

export const authCheckShadTokenAction = createAsyncThunk<IAuthCheckShadTokenResult, IAuthCheckRubikaTokenQuery>(
  'auth/checkShadToken',
  async ({ token: userToken }) => {
    return AuthService.checkShadToken(userToken, { disabledAutoError: true }).then(({ data: { data } }) => data);
  },
);
